//
// Copyright 2020 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/mesh/rtc.proto (package dxos.mesh.rtc, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { PublicKey } from "../keys_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import type { Signal } from "./swarm_pb.js";
import { file_dxos_mesh_swarm } from "./swarm_pb.js";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/mesh/rtc.proto.
 */
export const file_dxos_mesh_rtc: GenFile = /*@__PURE__*/
  fileDesc("ChNkeG9zL21lc2gvcnRjLnByb3RvEg1keG9zLm1lc2gucnRjIowBChFDb25uZWN0aW9uUmVxdWVzdBImCghwcm94eV9pZBgBIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkSEQoJaW5pdGlhdG9yGAIgASgIEhcKD3JlbW90ZV9wZWVyX2tleRgDIAEoCRIUCgxvd25fcGVlcl9rZXkYBCABKAkSDQoFdG9waWMYBSABKAkiYAoNU2lnbmFsUmVxdWVzdBImCghwcm94eV9pZBgBIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkSJwoGc2lnbmFsGAIgASgLMhcuZHhvcy5tZXNoLnN3YXJtLlNpZ25hbCI2CgxDbG9zZVJlcXVlc3QSJgoIcHJveHlfaWQYASABKAsyFC5keG9zLmtleXMuUHVibGljS2V5IjgKDkRldGFpbHNSZXF1ZXN0EiYKCHByb3h5X2lkGAEgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleSIiCg9EZXRhaWxzUmVzcG9uc2USDwoHZGV0YWlscxgBIAEoCSI2CgxTdGF0c1JlcXVlc3QSJgoIcHJveHlfaWQYASABKAsyFC5keG9zLmtleXMuUHVibGljS2V5IjcKDVN0YXRzUmVzcG9uc2USJgoFc3RhdHMYASABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0YgZwcm90bzM", [file_dxos_keys, file_dxos_mesh_swarm, file_google_protobuf_struct]);

/**
 * @generated from message dxos.mesh.rtc.ConnectionRequest
 */
export type ConnectionRequest = Message<"dxos.mesh.rtc.ConnectionRequest"> & {
  /**
   * @generated from field: dxos.keys.PublicKey proxy_id = 1;
   */
  proxyId?: PublicKey;

  /**
   * @generated from field: bool initiator = 2;
   */
  initiator: boolean;

  /**
   * @generated from field: string remote_peer_key = 3;
   */
  remotePeerKey: string;

  /**
   * @generated from field: string own_peer_key = 4;
   */
  ownPeerKey: string;

  /**
   * @generated from field: string topic = 5;
   */
  topic: string;
};

/**
 * Describes the message dxos.mesh.rtc.ConnectionRequest.
 * Use `create(ConnectionRequestSchema)` to create a new message.
 */
export const ConnectionRequestSchema: GenMessage<ConnectionRequest> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_rtc, 0);

/**
 * @generated from message dxos.mesh.rtc.SignalRequest
 */
export type SignalRequest = Message<"dxos.mesh.rtc.SignalRequest"> & {
  /**
   * @generated from field: dxos.keys.PublicKey proxy_id = 1;
   */
  proxyId?: PublicKey;

  /**
   * @generated from field: dxos.mesh.swarm.Signal signal = 2;
   */
  signal?: Signal;
};

/**
 * Describes the message dxos.mesh.rtc.SignalRequest.
 * Use `create(SignalRequestSchema)` to create a new message.
 */
export const SignalRequestSchema: GenMessage<SignalRequest> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_rtc, 1);

/**
 * @generated from message dxos.mesh.rtc.CloseRequest
 */
export type CloseRequest = Message<"dxos.mesh.rtc.CloseRequest"> & {
  /**
   * @generated from field: dxos.keys.PublicKey proxy_id = 1;
   */
  proxyId?: PublicKey;
};

/**
 * Describes the message dxos.mesh.rtc.CloseRequest.
 * Use `create(CloseRequestSchema)` to create a new message.
 */
export const CloseRequestSchema: GenMessage<CloseRequest> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_rtc, 2);

/**
 * @generated from message dxos.mesh.rtc.DetailsRequest
 */
export type DetailsRequest = Message<"dxos.mesh.rtc.DetailsRequest"> & {
  /**
   * @generated from field: dxos.keys.PublicKey proxy_id = 1;
   */
  proxyId?: PublicKey;
};

/**
 * Describes the message dxos.mesh.rtc.DetailsRequest.
 * Use `create(DetailsRequestSchema)` to create a new message.
 */
export const DetailsRequestSchema: GenMessage<DetailsRequest> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_rtc, 3);

/**
 * @generated from message dxos.mesh.rtc.DetailsResponse
 */
export type DetailsResponse = Message<"dxos.mesh.rtc.DetailsResponse"> & {
  /**
   * @generated from field: string details = 1;
   */
  details: string;
};

/**
 * Describes the message dxos.mesh.rtc.DetailsResponse.
 * Use `create(DetailsResponseSchema)` to create a new message.
 */
export const DetailsResponseSchema: GenMessage<DetailsResponse> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_rtc, 4);

/**
 * @generated from message dxos.mesh.rtc.StatsRequest
 */
export type StatsRequest = Message<"dxos.mesh.rtc.StatsRequest"> & {
  /**
   * @generated from field: dxos.keys.PublicKey proxy_id = 1;
   */
  proxyId?: PublicKey;
};

/**
 * Describes the message dxos.mesh.rtc.StatsRequest.
 * Use `create(StatsRequestSchema)` to create a new message.
 */
export const StatsRequestSchema: GenMessage<StatsRequest> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_rtc, 5);

/**
 * @generated from message dxos.mesh.rtc.StatsResponse
 */
export type StatsResponse = Message<"dxos.mesh.rtc.StatsResponse"> & {
  /**
   * @generated from field: google.protobuf.Struct stats = 1;
   */
  stats?: JsonObject;
};

/**
 * Describes the message dxos.mesh.rtc.StatsResponse.
 * Use `create(StatsResponseSchema)` to create a new message.
 */
export const StatsResponseSchema: GenMessage<StatsResponse> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_rtc, 6);

